'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableRow = function (_BcReactComponent) {
  _inherits(TableRow, _BcReactComponent);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.bindAll('renderFields', 'localizedValue');
    return _this;
  }

  _createClass(TableRow, [{
    key: 'localizedValue',
    value: function localizedValue(value, field, row) {
      var _props = this.props,
          intl = _props.intl,
          index = _props.index;


      if (!value) {
        return null;
      }

      switch (field.type) {
        case 'Date':
          return intl.formatDate((0, _moment2.default)(value).toDate(), { year: 'numeric', day: 'numeric', month: 'short' });
        case 'Currency':
          return '$' + intl.formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        default:
          if (field.localizationMap) {
            var localizationKey = field.localizationMap(value);
            return intl.formatMessage({ id: localizationKey, default: value });
          }
          if (field.transformationMap) {
            return field.transformationMap(value, index, row);
          }
          return value;
      }
    }
  }, {
    key: 'renderFields',
    value: function renderFields(field, index) {
      var _props2 = this.props,
          row = _props2.row,
          intl = _props2.intl;

      var keys = field.key.split('.');
      var value = row.getIn(keys);
      var className = (0, _classnames2.default)(field.type && field.type.toLowerCase(), {
        'no-wrap': field.noWrap,
        'right-align': field.rightAlign,
        'is-left-checkbox': field.leftAlignedCheckbox
      });
      return _react2.default.createElement(
        'td',
        { key: index, className: className, 'data-label': intl.formatMessage({ id: field.headerKey || field.key, default: field.key }) },
        _react2.default.createElement(
          'span',
          { className: 'cell-value' },
          this.localizedValue(value, field, row)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return _react2.default.createElement(
        'tr',
        { className: (this.props.selected ? 'selected-row' : '') + ' clearfix' },
        fields.map(this.renderFields)
      );
    }
  }]);

  return TableRow;
}(_baseBcReactComponent2.default);

TableRow.propTypes = {
  row: _react.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    key: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string.isRequired,
    localizationMap: _react.PropTypes.func
  }).isRequired).isRequired,
  selected: _react.PropTypes.bool,
  intl: _reactIntl.intlShape
};

TableRow.defaultProps = {
  selected: false
};

exports.default = (0, _reactIntl.injectIntl)(TableRow);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-row/components/TableRow.component.js
// module id = 1353
// module chunks = 1